module.exports = __webpack_public_path__ + "img/francis-goeltner-arena-tournament.9e98c26f.jpg";